import { Grid, TextField } from "@mui/material";
import MuiDatePicker from "@mui/lab/DatePicker";
import PickersDay from "@mui/lab/PickersDay";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import moment from "moment";

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== "dayIsBetween" && prop !== "isFirstDay" && prop !== "isLastDay",
})(({ theme, dayIsBetween }) => ({
  ...(dayIsBetween && {
    borderRadius: 0,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
}));

const styles = {
  separator: {
    textAlign: "center",
    lineHeight: "48px",
    display: {
      sm: "block",
      xs: "none",
    },
  },
};

const WeekPicker = (props) => {
  const { label, date, onChange } = props;

  const [value, setValue] = useState(date ? date : moment());

  const dayRenderer = (d, _selectedDates, pickersDayProps) => {
    if (!value) {
      return <PickersDay {...pickersDayProps} />;
    }

    d.hour(12);

    let start = value.clone().startOf("week").startOf("day");
    const startMonth = value.clone().startOf("month").startOf("day");
    if (start < startMonth) start = startMonth;
    const end = value.clone().endOf("week").endOf("day");

    const dayIsBetween = d.isBetween(start, end);

    return (
      <CustomPickersDay
        {...pickersDayProps}
        disableMargin
        dayIsBetween={dayIsBetween}
      />
    );
  };

  const inputRenderer = (params) => {
    const start = value?.clone()?.startOf("week");
    const end = value?.clone()?.endOf("week");

    params.inputProps.value = end?.format("DD.MMMM YYYY");

    return (
      <Grid container>
        <Grid item xs={12} sm={5}>
          <TextField
            label={params.label}
            value={start?.format("DD.MMMM YYYY")}
            variant="standard"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={1} sx={styles.separator}>
          -
        </Grid>
        <Grid item xs={12} sm={5}>
          <TextField {...params} label=" " variant="standard" fullWidth />
        </Grid>
      </Grid>
    );
  };

  const dateChange = (date) => {
    let start = date.clone().startOf("week").startOf("day");
    let end = date.clone().endOf("week").endOf("day");

    setValue(date);
    onChange(start, end);
  };

  return (
    <MuiDatePicker
      label={label}
      value={value}
      inputFormat="DD.MMMM YYYY"
      disableMaskedInput={true}
      onChange={dateChange}
      renderDay={dayRenderer}
      renderInput={inputRenderer}
    />
  );
};

export default WeekPicker;
